<!--
Este componente recibe como parametros las varibles de control de visibilidad de
las flechas de avanzar y retroceder (atrasVisible y adelanteVisible). También recibe los diálogoa reproducir.
El componente automáticamente actualiza el texto (currentText) y devuelve el nuevo valor
a través de la función :update:currentText para notificar al padre.
recibe instructor: Number (tres instructores)
NOTA: Se asume que los diálogos siempre van a empezar en el diálogo 0
-->
<template>
    <v-layout align-center justify-center row>
        <v-flex class="animated fadeInDown">
            <v-layout align-center justify-center row class="cont-dialogo">
                <div class="personaje text-xs-center animated flipInY dura-2" xs3 md2 >
                    <img :src="require('@/assets/imagenes_compartidas/tucan-' + tucan + '.png')">
                </div>
                <v-flex class="dialogos" :class="{'dialogos-center':diagCenter}" xs12 md10 >
                    <div @click="adelante" class="flecha-adelante diagnav hvr animated pulse animainfinite"
                            v-show="adelanteVisible && currentText < dialogos.length - 1">
                        <img src="@/assets/imagenes_compartidas/flecha_azul_i.svg" alt="">
                    </div>
                    <div @click="atras" class="flecha-atras diagnav hvr animated bounceIn"
                            v-show="atrasVisible && currentText>0">
                        <img src="@/assets/imagenes_compartidas/flecha_azul_d.svg" alt="">
                    </div>
                    <v-layout align-center justify-center class="ml-2" row>
                        <v-flex>
                            <p :id="'diag-'+idx" :key="idx" v-for="(dialogo, idx) in dialogos"
                               v-show="currentText == idx"><span v-html="dialogo"></span></p>
                            <slot></slot>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout>
</template>

<script>
    export default {
        props: {
            atrasVisible: {
                type: Boolean,
                default: true
            },
            adelanteVisible: {
                type: Boolean,
                default: true
            },
            dialogos: {
                type: Array,
                required: true
            },
            tucan: {
                type: String,
                default: "0"
            },
            diagCenter:{
                type:Boolean,
                default:false
            }
        },
        data() {
            return {
                imgTucan: '',
                currentText: 0,
                arrTucan: [""],
                background: ''
            }
        },
        created() {
            for (var i = 0; i < 3; i++) {
                this.getPng('', data => {
                    this.arrTucan.push(data);
                });
            }
            this.cambiarTucan(this.tucan);
        },
        methods: {
            atras() {
                this.currentText--;
                this.$emit('update:currentText', this.currentText);
            },
            adelante() {
                this.currentText++;
                this.$emit('update:currentText', this.currentText);
            },
            saltarAlDialogo(numeroDialogo) {
                this.currentText = numeroDialogo;
                this.$emit('update:currentText', this.currentText);
            },
            cambiarTucan(numTucan) {
                this.imgTucan = this.arrTucan[numTucan];
            }
        },
        watch: {
            Tucan: function (newVal, oldVal) { // watch it
                this.cambiarTucan(newVal);
            }
        }

    }
</script>

<style lang="scss" scoped>
@import '../sass/globals';
// .cont-dialogo{
//     border:solid red;
// }
.personaje {
    z-index: 1;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    padding-bottom:5px;
    margin-right: -40px;
    width: 80px;
    height: 80px;
    img {
        width: 100px;
    }
    @media screen and (min-width: 900px) {
        margin-right: -70px;
        
    }
}

.dialogos {
    position: relative;
    padding: 15px;
    padding-left: 55px;
    padding-right: 30px;
    margin: 0 auto;
    border-radius: 4px;
    text-align: left;
    p {
        margin: 0;
        font-size: 13px;
    }
    margin-bottom: 8px;
    background-color: #D3D2D2;
}
.diagnav {
    width:30px;
    height: 100%;
    cursor: pointer;
    right: 2px;
    color: black;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    img{
        width: 20px;
        height: 30px;
    }
}
.flecha-atras {
    left: 35px;
    top: 0;
}
.flecha-adelante {
    right: 0;
    top: 0;
    img{
        filter: drop-shadow(0px 4px 2px white);
        
    }
}
p {
    font-family:Poppins-Regular;
    line-height: 1.3em;
}
.dialogos-center{
    text-align: center;
}
.animainfinite{
    animation-iteration-count: infinite;
    animation-duration: 0.7s;
}

</style>
